let baseBackendUrl;
if (process.env.NODE_ENV !== 'production') {
    baseBackendUrl = 'http://0.0.0.0:9292/';
} else {
    baseBackendUrl = 'http://development.skd4eppm2v.us-east-1.elasticbeanstalk.com/';
}

export const BASE_URL = baseBackendUrl;

export const CDN_PROVIDERS = {
    'ak': {name:'Akamai', code:'CDN1'},
    'fy': {name:'Fastly', code:'CDN2'},
    'cf': {name:'CloudFront', code:'CDN3'},
    'mc': {name:'Cloudinary Multi-CDN', code:'Multi-CDN'}
};



/** WEBPACK FOOTER **
 ** ./src/js/constants/cdnConstants.js
 **/